import React, { forwardRef } from 'react';

// DEPENDENCIES
import isFunction from 'lodash/isFunction';

// GLOBAL FUNCTIONS
import { apiFetch, bugLog, doCallback } from 'functions.js';

// MAIN COMPONENT
export const formSubmit = Component => forwardRef(({
  onSubmit,
  method = 'POST',
  endpoint,
  queryParams,
  onFetch,
  onResponse,
  onSuccess,
  onError,
  loadingMessage,
  successMessage,
  errorMessage,
  messageFunctions,
  formatParams,
  resetOnSuccess = false,
  ...props
}, ref) => {

  // SUBMIT HANDLER
  const handleSubmit = (values, formikProps) => {
    const {
      debugOnly,
      debug
    } = props;

    bugLog(values, debug);

    const params = isFunction(formatParams) ? formatParams(values) : values;

    const args = {
      method,
      endpoint,
      queryParams,
      onFetch,
      onResponse,
      onSuccess : resetOnSuccess ? data => {
        formikProps.resetForm();
        doCallback(onSuccess, data);
      } : onSuccess,
      onError,
      loadingMessage,
      successMessage,
      errorMessage,
      messageFunctions,
      debugOnly,
      debug
    }

    if (onSubmit) onSubmit(params, args);
    else {
      const { onComplete } = args;
      apiFetch({
        params,
        ...args,
        onComplete: () => {
          if (onComplete) onComplete();
          formikProps.setSubmitting(false); // Ensure this is set to false: https://stackoverflow.com/questions/68912707/when-is-formiks-issubmitting-set-back-to-false
        }
      })
    }
  }

  // RENDER
  return <Component {...props} onSubmit={handleSubmit} messageFunctions={messageFunctions} ref={ref} />;
})
